import React from "react";
import {
    Box,
    CloseButton,
    Flex,
    Image,
    Link,

} from "@chakra-ui/react";
import { LinkItems, NavItem } from "./NavItem";
import { useAuth } from "../../hooks/useAuth";

const SidebarContent = ({ onClose, ...rest }) => {

    const auth = useAuth()
    return (
        <Box
            bg="dark.500"
            // borderRight="1px"
            // borderColor="dark.900"
            boxShadow="dark-lg"
            w={{ base: "full", md: "20vw", lg: "15vw" }}
            pos="fixed"
            h="full"

            zIndex={5}
            {...rest}
        >
            <Flex h="20" alignItems="center" justifyContent="space-between" mx={5} my={2} onClick={onClose}>
                <Link to="/">
                    <Image
                        src={`${process.env.PUBLIC_URL}/assets/logo_beatstake/beatstake.gif`}
                        w="4rem"
                        alt="Logo"
                        cursor="pointer"
                    />
                </Link>
                <CloseButton as="button" display={{ base: "flex", md: "none" }} size="xl" variant="solid" onClick={onClose} />
            </Flex>
            <Flex direction="column" alignItems="center" justify="center" h="60vh"> 

                {LinkItems.map((link) => (
                    <NavItem key={link.name} link={link.link} onClick={onClose}>
                        {link.name}
                    </NavItem>
                ))}

                {
                    auth.user && auth.user.account_type !== "fan" &&
                    <NavItem key="subscription"  link="/subscriptions" onClick={onClose} >
                        Subscriptions
                    </NavItem>
                }
            </Flex>
        </Box>
    );
};

export default SidebarContent;
